<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">SH-10 Register of shares or other securities bought-back</strong>
      </span>
      <span style="float: right">
        <!-- <a [routerLink]="['/sh-10/add']"> -->
          <button (click)="addsh10()"  class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
          [appHasPermission]="{'Url': '/register/mastersh10list/edit?goveva=true&email=', 'method':'put', 'menu': 'mastersh10list'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <!-- <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>Generate Output </span>
        </button>
      </span> -->
    </div>
          <!-- Date Filter  -->
            <section class="card search-box">
                <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span
                    class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
                <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
                  <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                           
                            <!-- <div class="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                              <label>Date of closing of buy-back offer</label>
                              <div class="input-group">
                                From Date:&nbsp;
                                <input class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                                  #b="ngbDatepicker" (click)="b.toggle();a.close();" [(ngModel)]="dateOfClosingBBO">
                                <button class="input-group-addon" (click)="b.toggle();a.close();" type="button">
                                  <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                </button>
                              </div>
                            </div>
                            <div class="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                              <label>Date of opening of buy-back offer</label>
                              <div class="input-group">
                                To Date:&nbsp;
                                <input class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker
                                  #a="ngbDatepicker" (click)="a.toggle();b.close();" [(ngModel)]="dateOfOpeningBBO">
                                <button class="input-group-addon" (click)="a.toggle();b.close();" type="button">
                                  <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                                </button>
                              </div>
                            </div> -->
  
                            <div class="col-md-3">
                              <!-- <label>Date of buy-back offer</label> -->
                              <br>
                              <div class="input-group" (click)="$event.stopPropagation()">
                                From:&nbsp;
                                <input id="dateOfClosingBBO" class="form-control" [minDate]="futureToDate"
                                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfClosingBBO" ngbDatepicker
                                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfClosingBBO">
                                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                            </div>
  
                            <div class="col-md-3">
                
                              <br>
                              <div class="input-group" (click)="$event.stopPropagation()">
                                 To:&nbsp;
                                <input id="dateOfOpeningBBO" class="form-control" [minDate]="futureToDate"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfOpeningBBO" ngbDatepicker
                                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfOpeningBBO">
                              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                              </div>
  
                            </div>
  
  
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                              <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                              <br>
                              <div class="input-group">
                                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                                  <i class="fa fa-search"></i>&nbsp;Search</button>
                                &nbsp;&nbsp;&nbsp;
                                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                                  (click)="clearAdvSearch()">
                                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                              </div>
                            </div>
                          </div>
                      <!-- <form (document:click)="appDate.close();cesDate.close();">
                        <div class="row">
                          <div class="col-lg-2">
                            <label>From Date :
                            </label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="fromDatecal" [maxDate]="futureFromDate" class="form-control"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dpAppointment"
                                ngbDatepicker #appDate="ngbDatepicker" (click)="appDate.toggle();cesDate.close();"
                                (ngModelChange)="setTodate($event)" [(ngModel)]="FromDateModelInMasterDirector">
                              <button class="input-group-addon" (click)="appDate.toggle();cesDate.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <label>To Date :
                            </label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="toDatecal" [minDate]="futureToDate" class="form-control"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dpCessation" ngbDatepicker
                                #cesDate="ngbDatepicker" (click)="cesDate.toggle();appDate.close();"
                                [(ngModel)]="ToDateModelInMasterDirector" (ngModelChange)="setFromdate($event)">
                              <button class="input-group-addon" (click)="cesDate.toggle();appDate.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <label>&nbsp;&nbsp;&nbsp;</label>
                            <div class="input-group">
                              <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2"
                                (click)="doAdvSearch()">
                                <i class="fa fa-search"></i>Search</button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                                (click)="clearAdvSearch()">
                                <i class="fa fa-refresh"></i>Clear</button>
                            </div>
                          </div>
                        </div>
                      </form> -->
                    </div>
                  </div>
                </div>
              </section>
              <!-- Date filter End -->
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
                          class="table table-hover compact cell-border nowrap stripe" id="mastersh10Table"
                          style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>Resolution Pass Date</th>
                              <th>Date of Opening of Buy Back Offer</th>
                              <th>Date of Closing of Buy Back Offer</th>
                              <th>Approval Date</th>
                              <th class="actionclass">Action
                                <!-- <span
                                  [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}">Action</span> -->
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let director of registerDirectorList;let i=index">
                              <td>
                                {{director.dateofpassingspecialresolution | date : "dd-MM-y"}}
                              </td>
                              <td>
                                <!-- <span style="display: none">{{director.dateofopeningbboffer | date : "yMMdd"}}</span> -->
                                {{director.dateofopeningbboffer | date : "dd-MM-y"}}
                              </td>
                              <td>
                                {{director.dateofclosingbb | date : "dd-MM-y"}}
                              </td>
                              <td>
                                {{director.dateofapproval | date : "dd-MM-y"}}
                              </td>
                              <td style='white-space: nowrap'>
                                <div class="input-group">
                                  <button type="button" (click)="editsh10detail(director._id)" [appHasPermission]="{'Url': '/register/mastersh10list/edit?goveva=true&email=', 'method':'put', 'menu': 'mastersh10list'}"
                                    class="btn-sm btn btn-warning">
                                    <span class="fa fa-pencil"></span>
                                  </button>
                                  &nbsp;&nbsp;
                                  <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mastersh10list/edit?goveva=true&email=', 'method':'put', 'menu': 'mastersh10list'}">
                                  <span class="icmn-bin"></span>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      </section>
  
        <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
          style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    Are you sure you want to delete SH-10 details?
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" (click)="deletesh10detail()">
                  <i class="fa fa-check"></i>&nbsp;Yes
                </button>
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                  <i class="fa fa-times"></i>&nbsp;No
                </button>
              </div>
            </div>
          </div>
        </div>
  <app-alert></app-alert>